<template>
  <div>
    <div class="date-range-picker" @click="onShowTime">
      <div class="time-range">
        <p class="time">{{ defaultTime[0].format('HH:mm') }}</p>
        <p class="date">
          {{ defaultTime[0].format($t('MM月DD日')) }}
          {{ defaultTime[0].format('dddd') }}
        </p>
      </div>
      <div class="icon">
        <img :src="arrowRight" alt="" />
      </div>
      <div class="time-range">
        <p class="time">{{ defaultTime[1].format('HH:mm') }}</p>
        <p class="date">
          {{ defaultTime[1].format($t('MM月DD日')) }}
          {{ defaultTime[1].format('dddd') }}
        </p>
      </div>
    </div>
    <van-popup
      v-model="showTime"
      class="popupBox"
      position="bottom"
      safe-area-inset-bottom
      round
      overlay-class="overlay"
      @click-overlay="onCancel"
    >
      <div class="select-box">
        <div class="close" @click="onCancel">{{ $t('取消') }}</div>
        <p class="title">{{ $t('选择时间') }}</p>
        <div class="submit" @click="onSubmit">{{ $t('确定') }}</div>
      </div>
      <div class="selcet-date">
        <div class="date-range-picker-select">
          <div
            class="time-range"
            @click="onStart"
            :class="{ clicked: click === 0 }"
          >
            <p class="time">{{ timeArray[0].format('HH:mm') }}</p>
            <p class="date">
              {{ timeArray[0].format($t('MM月DD日')) }}
              {{ timeArray[0].format('dddd') }}
            </p>
          </div>
          <div class="icon">
            <img :src="arrowRight" alt="" />
          </div>
          <div
            class="time-range"
            @click="onEnd"
            :class="{ clicked: click === 1 }"
          >
            <p class="time">{{ timeArray[1].format('HH:mm') }}</p>
            <p class="date">
              {{ timeArray[1].format($t('MM月DD日')) }}
              {{ timeArray[1].format('dddd') }}
            </p>
          </div>
        </div>
        <van-picker
          ref="picker"
          :columns="columns"
          v-model="showPicker"
          class="custom-datetime-picker"
          @change="onChange"
          item-height="48px"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { Popup, DatetimePicker, Picker, Toast } from 'vant'
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Picker)
import arrowRight from '@/assets/images/arrow-right.svg'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    isClickable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const now = dayjs()
    const nextHour =
      now.minute() === 0 && now.second() === 0
        ? now
        : now.add(1, 'hour').set('minute', 0).set('second', 0)
    const defaultStartTime = nextHour
    const defaultEndTime = defaultStartTime.add(1, 'hour')

    return {
      internalValue: this.value,
      defaultTime: [
        this.startTime ? dayjs(this.startTime) : defaultStartTime,
        this.endTime ? dayjs(this.endTime) : defaultEndTime,
      ],

      timeArray: [
        this.startTime ? dayjs(this.startTime) : defaultStartTime,
        this.endTime ? dayjs(this.endTime) : defaultEndTime,
      ],

      arrowRight,
      showTime: false,
      showPicker: [],
      columns: [],
      selectedValues: ['', ''],
      click: 0,
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', this.internalValue)
    },
    getColumns() {
      const startDate = dayjs()
      const endDate = startDate.add(6, 'month')
      let datesArray = []

      for (
        let currentDate = startDate;
        currentDate.isBefore(endDate);
        currentDate = currentDate.add(1, 'day')
      ) {
        datesArray.push(currentDate.format(this.$t('MM月DD日 dddd')))
      }

      this.columns = [
        { values: datesArray, className: 'day-column' },
        {
          values: Array.from(
            { length: 24 },
            (_, i) => `${i.toString().padStart(2, '0')}`
          ),
          className: 'hour-column',
        },
        {
          values: Array.from(
            { length: 60 },
            (_, i) => `${i.toString().padStart(2, '0')}`
          ),
          className: 'minute-column',
        },
      ]
    },
    getDaysInMonth(year, month) {
      return dayjs(`${year}-${month}-01`).daysInMonth()
    },
    onChange(selectedValues, selectedIndex) {
      const [dateStr, hour, minute] = selectedIndex
      const [month, day] = dateStr.split(this.$t('日'))[0].split(this.$t('月'))
      const formattedMonth = month.padStart(2, '0')
      const formattedDay = day.padStart(2, '0')
      const currentYear = dayjs().year()
      const dateFormatted = `${currentYear}-${formattedMonth}-${formattedDay}`

      const date = dayjs(
        `${dateFormatted} ${hour}:${minute}`,
        'YYYY-MM-DD HH:mm'
      )
      let timeArray = [...this.timeArray]

      if (this.click === 0) {
        timeArray[this.click] = date
        // const endDate = timeArray[1]
        // timeArray[1] = dayjs(
        //   `${date.format('YYYY-MM-DD')} ${endDate.format('HH:mm')}`,
        //   'YYYY-MM-DD HH:mm'
        // )
      } else {
        timeArray[this.click] = date
      }

      this.timeArray = timeArray
    },
    onSubmit() {
      let [startTime, endTime] = this.timeArray
      if (startTime.isAfter(endTime)) {
        this.$toast.fail(this.$t('开始时间不能晚于结束时间'))
        return
      } else if (endTime.isBefore(startTime)) {
        this.$toast.fail(this.$t('结束时间不能早于开始时间'))
        return
      }
      this.defaultTime = this.timeArray
      this.$emit('update-time', {
        timeArray: this.timeArray,
        isCrossDayVisit: this.isCrossDayVisit
      })
      this.showTime = false

      // 检查是否跨天
      if (this.isCrossDayVisit && !this.IsSubscribe) {
        Toast.fail('跨天预约不支持会议室预约')
        return
      }
    },
    onStart() {
      this.click = 0
      const now = this.timeArray[0]
      const defaultDate = now.format(this.$t('MM月DD日 dddd'))
      const defaultHour = now.hour().toString().padStart(2, '0')
      const defaultMinute = now.minute().toString().padStart(2, '0')
      const newValues = [defaultDate, defaultHour, defaultMinute]
      this.selectedValues = newValues
      const startDate = dayjs()
      const endDate = startDate.add(6, 'month')
      let datesArray = []

      for (
        let currentDate = startDate;
        currentDate.isBefore(endDate);
        currentDate = currentDate.add(1, 'day')
      ) {
        datesArray.push(currentDate.format(this.$t('MM月DD日 dddd')))
      }
      this.$set(this.columns, 0, {
        values: datesArray,
        className: 'day-column',
      })

      this.$nextTick(() => {
        const picker = this.$refs.picker
        if (picker) {
          picker.setValues(newValues)
        }
      })
    },
    onEnd() {
      this.click = 1

      const startDate = dayjs()
      const endDate = startDate.add(6, 'month')
      let datesArray = []

      // 结束时间可跨天 → 日期列要恢复为所有日期
      for (
        let currentDate = startDate;
        currentDate.isBefore(endDate);
        currentDate = currentDate.add(1, 'day')
      ) {
        datesArray.push(currentDate.format(this.$t('MM月DD日 dddd')))
      }

      // 默认值：结束时间对应的日期 + 时分
      const end = this.timeArray[1]
      const defaultDate = end.format(this.$t('MM月DD日 dddd'))
      const defaultHour = end.hour().toString().padStart(2, '0')
      const defaultMinute = end.minute().toString().padStart(2, '0')
      const newValues = [defaultDate, defaultHour, defaultMinute]
      this.selectedValues = newValues

      // 设置 picker 的日期列（这里改成全部日期，而不是 [defaultDate]）
      this.$set(this.columns, 0, {
        values: datesArray,
        className: 'day-column',
      })

      this.$nextTick(() => {
        const picker = this.$refs.picker
        if (picker) {
          picker.setValues(newValues)
        }
      })
    },
    onShowTime() {
      if (!this.isClickable) {
        return
      }
      this.click = 0
      this.$nextTick(() => {
        this.setDefaultPickerValues()
      })
      this.showTime = true
    },
    onCancel() {
      this.timeArray = [...this.defaultTime]
      this.showTime = false
    },
    setDefaultPickerValues() {
      const now = this.timeArray[0]
      const defaultDate = now.format(this.$t('MM月DD日 dddd'))
      const defaultHour = now.hour().toString().padStart(2, '0')
      const defaultMinute = now.minute().toString().padStart(2, '0')
      const newValues = [defaultDate, defaultHour, defaultMinute]

      const startDate = dayjs()
      const endDate = startDate.add(6, 'month')
      let datesArray = []

      for (
        let currentDate = startDate;
        currentDate.isBefore(endDate);
        currentDate = currentDate.add(1, 'day')
      ) {
        datesArray.push(currentDate.format(this.$t('MM月DD日 dddd')))
      }
      this.$set(this.columns, 0, {
        values: datesArray,
        className: 'day-column',
      })

      this.$nextTick(() => {
        const picker = this.$refs.picker
        if (picker) {
          picker.setValues(newValues)
        }
      })
    },
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    },
    startTime(newStartTime) {
      if (newStartTime) {
        this.$set(this.defaultTime, 0, dayjs(newStartTime))
        this.$set(this.timeArray, 0, dayjs(newStartTime))
      }
    },
    endTime(newEndTime) {
      if (newEndTime) {
        this.$set(this.defaultTime, 1, dayjs(newEndTime))
        this.$set(this.timeArray, 1, dayjs(newEndTime))
      }
    },
  },
  computed: {
    isCrossDayVisit() {
      const [start, end] = this.timeArray

      if (!start || !end) return false

      // 比较格式化后的日期是否相同
      return start.format('YYYY-MM-DD') !== end.format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.getColumns()
  },
  created() {
    const startDate = dayjs()
    const endDate = startDate.add(6, 'month')
    let datesArray = []

    for (
      let currentDate = startDate;
      currentDate.isBefore(endDate);
      currentDate = currentDate.add(1, 'day')
    ) {
      datesArray.push(currentDate.format(this.$t('MM月DD日 dddd')))
    }
  },
}
</script>
<style lang="less" scoped>
.date-range-picker {
  width: 351px;
  height: 72px;
  background: #fefffe;
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .time-range {
    height: 48px;
    .time {
      font-family: 'Lato';
      font-weight: bold;
      font-size: 18px;
      color: #1e2329;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
    .date {
      font-size: 16px;
      font-weight: 400;
      color: #474d57;
      line-height: 24px;
      text-align: left;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
    }
  }
  .icon {
    width: 24px;
    height: 24px;
  }
}
.selcet-date {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.date-range-picker-select {
  width: 351px;
  height: 72px;
  background: #fefffe;
  border-radius: 8px;
  border: 1px solid #3972ff;
  padding-left: 7px;
  padding-right: 7px;
  margin-top: 16px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .time-range {
    height: 100%;
    width: 217px;
    padding-left: 10px;
    padding-top: 10px;

    .time {
      font-family: 'Lato';
      font-weight: bold;
      font-size: 18px;
      color: #1e2329;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
    .date {
      font-size: 16px;
      font-weight: 400;
      color: #474d57;
      line-height: 24px;
      text-align: left;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
    }
  }
  .time-range.clicked {
    border-bottom: 3px solid #3972ff;
  }
  .icon {
    width: 24px;
    height: 24px;
  }
}
.popupBox {
  overflow: hidden;
}
.select-box {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .submit {
    width: 94px;
    height: 100%;
    line-height: 56px;
    font-size: 16px;
    font-weight: 500;
    color: #3972ff;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #1e2329;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
  }
  .close {
    width: 94px;
    height: 100%;
    line-height: 56px;
    font-size: 16px;
    font-weight: 500;
    color: #1e2329;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
  }
}
/deep/.timeList {
  position: relative;
  height: 275px;
  padding-left: 20px;
  padding-right: 16px;
  overflow: auto;

  .timeListCard {
    min-height: 80px;
    height: auto;
    border-bottom: 1px solid rgba(234, 236, 239, 0.5);
    padding: 16px 0px;
  }

  .timeListRange {
    font-size: 16px;
    font-weight: 400;
    color: #1e2329;
    line-height: 24px;
    text-align: left;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
    word-break: break-word;
    word-wrap: break-word;
  }
}
/deep/.overlay {
  background: rgba(30, 35, 41, 0.3);
}
.custom-datetime-picker {
  width: 100%;
  height: 240px;
  padding-left: 12px;
  padding-right: 20px;
}
/deep/.custom-datetime-picker .van-picker__toolbar {
  display: none; /* 隐藏顶部标题栏 */
}

/deep/.custom-datetime-picker .van-picker__columns {
  display: flex;
  gap: 10px;
}

/deep/.custom-datetime-picker .van-picker-column {
  flex: none; /* 防止等分 */
}
/deep/.custom-datetime-picker .day-column {
  width: 197px;
}

/deep/.custom-datetime-picker .hour-column {
  width: 64px;
}

/deep/.custom-datetime-picker .minute-column {
  width: 64px;
}
/deep/.custom-datetime-picker .van-picker-column__item .van-ellipsis {
  font-size: 14px !important;
  font-family: PingFangSC, PingFang SC !important;
  font-weight: 400 !important;
}
/deep/.custom-datetime-picker .van-picker-column__item--selected .van-ellipsis {
  font-size: 16px !important;
  font-family: PingFangSC, PingFang SC !important;
  font-weight: 500 !important;
}
</style>
